export const BANNER_CONTENT = `
banner {
  bannerText {
    html
  }
  linkTitle {
    url
    title
    class
    target
  }
}
`

export const BANNER = `
banner: entry(section: "global", site: $site) {
  ...on global_Entry {
    ${ BANNER_CONTENT }
  }
}
`
